import { IconNames } from 'components/icon';
import { PaymentMethodActionButtonType } from './enum';
export const IconToActionTypeMap = {
    [PaymentMethodActionButtonType.DELETE]: IconNames.TRASH,
    [PaymentMethodActionButtonType.PRIMARY]: IconNames.STAR_EMPTY,
    [PaymentMethodActionButtonType.UPDATE]: IconNames.EDIT,
};
